import { Pipe, PipeTransform } from '@angular/core';
import { SizePrice, OrderableIngredient, OrderedIngredient } from 'ngx-web-api';

@Pipe({
  name: 'recipeDeterminantSizePricesFilter',
})
export class RecipeDeterminantSizePricesFilterPipe implements PipeTransform {
  transform(
    sizePrices: SizePrice[],
    orderedIngredients: OrderedIngredient[],
    orderableIngredients: OrderableIngredient[],
    showSizeSpecificIngredients: boolean
  ): SizePrice[] {
    if (orderedIngredients && orderableIngredients && !showSizeSpecificIngredients) {
      for (const orderedIngredient of orderedIngredients) {
        const recipeDeterminantIngredient: OrderableIngredient = orderableIngredients.find(
          ingredient => ingredient.name === orderedIngredient.ingredient && ingredient.determinesRecipe
        );

        if (!!recipeDeterminantIngredient) {
          return sizePrices.filter(sizePrice => !!recipeDeterminantIngredient.getSizePrice(sizePrice.size));
        }
      }
    }

    return sizePrices;
  }
}
